import React from "react";
import Button from "@material-ui/core/Button";

import Auth from "../authConfigure";

// Gates its children behind eagle-pool SSO ("Agent" SAML provider). Used only
// around the Agent dashboard route - never wrap the Driver route with this,
// drivers have no Eagle account and would be locked out of the SMS link.
export const AuthGate = ({ children }) => {
  const [status, setStatus] = React.useState("checking"); // checking | signedIn | signedOut

  React.useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(() => setStatus("signedIn"))
      .catch(() => setStatus("signedOut"));
  }, []);

  if (status === "checking") {
    return null;
  }

  if (status === "signedOut") {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20vh" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => Auth.federatedSignIn({ customProvider: "Agent" })}
        >
          Sign in to continue
        </Button>
      </div>
    );
  }

  return children;
};
